export default __webpack_public_path__ + "static/media/refresh.68d06524.svg";